// Created by jarongallo at 6/17/21
import React, { useEffect, useState } from 'react';
import { useLazyQuery, useMutation } from '@apollo/react-hooks';
import { GET_SALESPERSON_INFO, UPDATE_SALESPERSON_INFO } from './queries';
import { toast } from 'react-toastify';
import UIListInputRow from '../../../../../../components/UI/UIListInputRow';
import * as strings from './strings';
import { UI_LABELED_INPUT_PHONE_NUMBER_TYPE, UI_LABELED_INPUT_TEXT_TYPE } from '../../../../../../components/UI/UILabeledInput/config';
import './styles';

export default function IndividualSalespersonInfoTab({ salespersonId }: IndividualSalespersonInfoTabProps) {
	const [salesperson, setSalesperson] = useState<UserType>();
	const [name, setName] = useState<string>();
	const [email, setEmail] = useState<string>();
	const [phoneNumber, setPhoneNumber] = useState<string>();
	const [isSaving, setIsSaving] = useState<object>({});

	const [updateSalespersonInfo] = useMutation(UPDATE_SALESPERSON_INFO);
	const [getSalespersonInfo, { data: salespersonData }] = useLazyQuery(GET_SALESPERSON_INFO, {
		variables: { id: salespersonId }
	});

	useEffect(() => {
		(async () => {
			await getSalespersonInfo();
		})();
	}, []);

	useEffect(() => {
		(async () => {
			if (salespersonData) {
				setSalesperson(salespersonData['user']);
				setName(salespersonData['user'].name);
				setEmail(salespersonData['user'].email);
				setPhoneNumber(salespersonData['user'].phoneNumber);
			}
		})();
	}, [salespersonData]);

	if (!salesperson) return null;

	const updateSalesperson = async (key: string, value: any) => {
		setIsSaving({ ...isSaving, [key]: true });
		let variables = {
			id: salespersonId,
			[key]: value
		};
		const response = await updateSalespersonInfo({ variables });
		const { updateUser } = response['data'];
		if (updateUser) {
			setIsSaving({ ...isSaving, [key]: false });
			toast.success(strings.infoSalespersonUpdateSuccess + key + '!');
			await getSalespersonInfo();
		}
	};

	return (
		<div className='salespersonInfo'>
			<UIListInputRow
				label={strings.nameLabel}
				containerStyle={{ width: '100%' }}
				isLoading={isSaving['name']}
				type={UI_LABELED_INPUT_TEXT_TYPE}
				savedValue={salesperson.name}
				onSave={() => updateSalesperson('name', name)}
				onChangeValue={(name) => setName(name)}
				value={name}
				placeholder={strings.namePlaceholder}
			/>
			<UIListInputRow
				label={strings.emailLabel}
				containerStyle={{ width: '100%' }}
				isLoading={isSaving['email']}
				type={UI_LABELED_INPUT_TEXT_TYPE}
				savedValue={salesperson.email}
				onSave={() => updateSalesperson('email', email)}
				onChangeValue={(email) => setEmail(email)}
				value={email}
				placeholder={strings.emailPlaceholder}
			/>
			<UIListInputRow
				label={strings.phoneNumberLabel}
				containerStyle={{ width: '100%' }}
				isLoading={isSaving['phoneNumber']}
				type={UI_LABELED_INPUT_PHONE_NUMBER_TYPE}
				savedValue={salesperson.phoneNumber}
				onSave={() => updateSalesperson('phoneNumber', phoneNumber)}
				onChangeValue={(phoneNumber) => setPhoneNumber(phoneNumber)}
				value={phoneNumber}
				placeholder={strings.phoneNumberPlaceholder}
			/>
		</div>
	);
}
